import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import leadsReducer from './slices/leadsSlice';
import leadStatusReducer from './slices/leadStatusSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['leads', 'leadStatus'] // Persist leads and leadStatus state
};

const rootReducer = combineReducers({
  leads: leadsReducer,
  leadStatus: leadStatusReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export default store;